import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './HeatmapSettingsButton.scss';

export default function HeatmapSettingsButton({ openHeatmapSettingsDialog }) {
  return (
    <ButtonWithIcon
      type="borderless"
      size="small"
      linkIconSize="s"
      sprite="Settings"
      layout="vertical"
      tabIndex="0"
      onClick={openHeatmapSettingsDialog || (() => {})}
      className="result-toolbar-heatmap-settings-button e2e-heatmap-settings"
      aria-label="Open heatmap settings">
      Settings
    </ButtonWithIcon>
  );
}

HeatmapSettingsButton.propTypes = {
  openHeatmapSettingsDialog: PropTypes.func.isRequired,
};
